import { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  createPlasticWithDrawItem,
  getAllPlasticWithDrawsItems,
  getDataForEdit,
  deletePlasticWithDrawItem,
  getBillListForVendor,
  getDataForAfterBill,
  adjustPlasticWithDrawItem,
} from "../../store/PlasticWithDraw/PlasticWithDrawSliceApi";

import {
  getAllVendorItems,
  getPlasticListItems,
} from "../../store/AppLevelApi/AppLevelApi";
import { plasticWithDrawSliceAction } from "../../store/PlasticWithDraw/PlasticWithDrawSlice";
import { headTitle } from "../../utility/GetTableListName";
import MainComponent from "../Base/MainComponent";
//importing constant form option to create form input
import { FormOptionsPlasticWithDraws } from "../../ConstantData/FormOptions";
//import constant form option to create duplicate field
import { AddMoreFormOptionsPlasticWithDraws } from "../../ConstantData/AddMoreFormOptions";
//importing inital form data to store value state
import { InitialPlasticWithDrawFormData } from "../../ConstantData/InitialData";
//imporint form data error

//for only adjusted form
import { ErrorPlasticWithDrawFormData } from "../../ConstantData/ErrorOption";
import { adjustedFormPlasticWithDraw } from "../../ConstantData/AdjustedFormOption";
import { InitialAdjustData } from "../../ConstantData/AdjustInitialData";

function PlasticWithDraw() {
  const [showOtherFormBtn, setShowOtherFormBtn] = useState(false); //for only adjust

  const [adjustInitialData, setAdjustInitialData] = useState(InitialAdjustData);

  let newFormOptionsPlasticWithDraw = JSON.parse(
    JSON.stringify(AddMoreFormOptionsPlasticWithDraws)
  );

  let newFormOptionsPlasticWithDrawText = JSON.parse(
    JSON.stringify(FormOptionsPlasticWithDraws)
  );
  let newAdjustedFormPlasticWithDraw = JSON.parse(
    JSON.stringify(adjustedFormPlasticWithDraw)
  );
  // let billDataList = useSelector((state) => state.cartoonWithDraw.billDataList);

  const dispatch = useDispatch();
  useEffect(() => {
    // dispatch(getProductItems("name"));
    // dispatch(getAllPlasticWithDrawsItems());
    // dispatch(getAllVendorItems());
    // dispatch(getPlasticListItems());
  }, []);

  const isSuccess = useSelector((state) => state.applevel.isSuccess);

  const plasticWithDrawList = useSelector(
    (state) => state.plasticwithdraw.plasticWithDrawList
  );
  console.log(plasticWithDrawList);
  //for normal form input data initilization
  const InitialFormDataStore = useSelector(
    (state) => state.plasticwithdraw.initialData
  );
  //for normal duplicate form input data initilization
  let InitialFormDuplicateDataStore = useSelector(
    (state) => state.plasticwithdraw.initialDuplicateData
  );

  const plasticWithDrawEditData = useSelector(
    (state) => state.plasticwithdraw.dataEdit
  );
  let plasticWithDrawFormError = useSelector(
    (state) => state.plasticwithdraw.errorData
  );

  let isError = useSelector((state) => state.plasticwithdraw.isError);
  plasticWithDrawFormError = {
    ...ErrorPlasticWithDrawFormData,
    ...plasticWithDrawFormError,
  };
  const vendorList = useSelector((state) => state.applevel.vendorList);
  const plasticList = useSelector((state) => state.applevel.plasticList);
  const billList = useSelector((state) => state.plasticwithdraw.billList);

  function addOptionForSelectFieldDuplicate(
    FormOption,
    list,
    optionName,
    type
  ) {
    if (type === "duplicate") {
      newFormOptionsPlasticWithDraw = FormOption.map((item) => {
        if (item?.labelName === optionName) {
          item.options = list;
        }

        return item;
      });
    } else {
      newAdjustedFormPlasticWithDraw = adjustedFormPlasticWithDraw.map(
        (item) => {
          if (item?.labelName === optionName) {
            item.options = list;
          }

          return item;
        }
      );
    }
  }
  function addOptionForSelectField(FormOption, list, optionName) {
    newFormOptionsPlasticWithDrawText = FormOption.map((item) => {
      if (item?.labelName === optionName) {
        item.options = list;
      }

      return item;
    });
  }

  if (vendorList.length > 0) {
    // to chage subquality option coming from server4
    addOptionForSelectField(
      newFormOptionsPlasticWithDrawText,
      vendorList,
      "Vendor"
    );
  }

  if (plasticList.length > 0) {
    // to chage product option coming from server
    addOptionForSelectFieldDuplicate(
      newFormOptionsPlasticWithDraw,
      plasticList,
      "Plastic Type",
      "duplicate"
    );
  }

  if (billList.length > 0) {
    // to chage product option coming from server
    addOptionForSelectFieldDuplicate(
      adjustedFormPlasticWithDraw,
      billList,
      "Bill Number",
      "adjusted"
    );
  } else {
    addOptionForSelectFieldDuplicate(
      adjustedFormPlasticWithDraw,
      [],
      "Bill Number",
      "adjusted"
    );
  }

  const setDataForAdjust = (type) => {
    if (vendorList.length > 0) {
      addOptionForSelectFieldDuplicate(
        adjustedFormPlasticWithDraw,
        vendorList,
        "Vendor",
        "adjusted"
      );
    }
  };

  const inputAdjustHandler = (name, value) => {
    //only for adjust not need for all

    const formData = JSON.parse(JSON.stringify(adjustInitialData)); //deep copy
    if (name === "bill_number") {
      setShowOtherFormBtn((prevState) => !prevState);
      // dispatch(getDataForAfterBill(value.value));
    }
    // if (name === "vendor") dispatch(getBillListForVendor(value.value));
    formData[name] = value;
    setAdjustInitialData(formData);
  };

  const headTitleLabel = headTitle(FormOptionsPlasticWithDraws, [
    "Product",
    "Plastic Quantity",
  ]); //array is filed that is included in list heading

  return (
    <MainComponent
      InitialFormData={InitialPlasticWithDrawFormData}
      getDataForEdit={getDataForEdit}
      delteFun={deletePlasticWithDrawItem}
      createFun={createPlasticWithDrawItem} //create function coming from store
      FormOptions={newFormOptionsPlasticWithDrawText}
      NewFormOptions={newFormOptionsPlasticWithDraw}
      OptionName="Create Plastic WithDraw"
      OptionNameList="Plastic WithDraw"
      generalList={plasticWithDrawList}
      headTitle={headTitleLabel}
      EditData={plasticWithDrawEditData}
      isError={isError}
      ErrorData={plasticWithDrawFormError}
      InitialFormDataStore={InitialFormDataStore}
      InitialFormDuplicateDataStore={InitialFormDuplicateDataStore}
      setErrorData={plasticWithDrawSliceAction.setErrorData}
      generalModuleList={vendorList} //list to add different module
      isNotDeleteBtn={true}
      extraAddBtn={true}
      extraButtonText={"Add Plastic"}
      FormStyle={"!w-[60%] !h-[40rem] custom-scroll-for-nav overflow-y-scroll "}
      secondCreateBtn={false} // to create second button to add extra form
      isSuccess={isSuccess}
      needAdjust={true} //it is used if there is no edit but need adjust
      adjustedFormWithDraw={adjustedFormPlasticWithDraw} //it is used if there is no edit but need adjust
      setDataForAdjust={setDataForAdjust}
      inputAdjustHandler={inputAdjustHandler} //it is used if there is no edit but need adjust
      InitialAdjustData={adjustInitialData} //it is used if there is no edit but need adjust
      listForLength={{ billList }}
      showOtherFormBtn={showOtherFormBtn} // //it is used if there is no edit but need adjust
      createAdjust={adjustPlasticWithDrawItem}
      notShowEditBtn={true} //use when you dont need edit btn
    />
  );
}

export default PlasticWithDraw;
